import List from "@/components/list";
import { tableBaseProps } from "@/utils/common.js";

const ReBindTable = (args) => {
  const AccountTableConfig = [
    tableBaseProps("姓名", "userName", "m100"),
    tableBaseProps("手机号码", "userMobile", "m100"),
    tableBaseProps("工作单位", "deptName", "m120"),
    tableBaseProps("单位及职务", "unitPosition", "m200"),
  ];

  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};

const FailBindTable = (args) => {
  const ErrorReason = ({ props: { vo } }) => {
    return <div domPropsInnerHTML={vo.row.errorReason}></div>;
  };

  const AccountTableConfig = [
    tableBaseProps("姓名", "userName", "m100"),
    tableBaseProps("手机号码", "userMobile", "m100"),
    tableBaseProps("工作单位", "deptName", "m120"),
    tableBaseProps("单位及职务", "unitPosition", "m200"),
    {
      ...tableBaseProps("错误原因", "errorReason", "m200"),
      render: (vo) => <ErrorReason vo={vo} />,
    },
  ];

  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};

export { ReBindTable, FailBindTable };
